import React from 'react';
import { observer } from 'mobx-react';
import {
    StyledStep,
    StyledStepTitle,
    StyledStepDescription,
    StyledIcon
} from './ReplenishmentTooltipModalStyles';
import { replenishmentStepTitleModalClass, replenishmentStepDescriptionModalClass } from './utils';

export const ReplenishmentTooltipModalStep = observer(({ icon, title, description }) => (
    <StyledStep>
        <StyledIcon src={icon} alt="" />
        <StyledStepTitle className={replenishmentStepTitleModalClass}>{title}</StyledStepTitle>
        <StyledStepDescription className={replenishmentStepDescriptionModalClass}>
            {description}
        </StyledStepDescription>
    </StyledStep>
));
